export type LogoDePrixia = 'clasico' | 'nuevo';

/** La única lectura de `VITE_LOGO_PRIXIA` en la mini (spec 344). Se fija al compilar. */
export function logoDePrixia(valor: unknown = import.meta.env.VITE_LOGO_PRIXIA): LogoDePrixia {
  return valor === 'nuevo' ? 'nuevo' : 'clasico';
}
